export default "__VITE_ASSET__DCkgn5xQ__"